export function formatMinutes(value) {
  const minutes = Math.max(0, Math.floor(Number(value) || 0));
  return `${Math.floor(minutes / 60)} Std. ${String(minutes % 60).padStart(2, '0')} Min.`;
}
export function timeLabel(value) {
  return value ? new Date(value).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : 'Noch eingestempelt';
}
